var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_3569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 5.33334H6.66634C5.92996 5.33334 5.33301 5.9303 5.33301 6.66668V13.3333C5.33301 14.0697 5.92996 14.6667 6.66634 14.6667H13.333C14.0694 14.6667 14.6663 14.0697 14.6663 13.3333V6.66668C14.6663 5.9303 14.0694 5.33334 13.333 5.33334Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 10.6667C1.93301 10.6667 1.33301 10.0667 1.33301 9.33334V2.66668C1.33301 1.93334 1.93301 1.33334 2.66634 1.33334H9.33301C10.0663 1.33334 10.6663 1.93334 10.6663 2.66668",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_3569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipIcon);
export default __webpack_public_path__ + "static/media/clip_icon.1ad0b1fe6d29a6d702996b224068bb47.svg";
export { ForwardRef as ReactComponent };